import { createActionGroup, props } from '@ngrx/store';
import { ISelectItem } from '@ra-web-tech-ui-toolkit/components';
import {
  IDeviceConfiguration,
  ISpace,
  IUpdateDevicesInformation,
  IblobDetails,
  Shift,
} from 'src/app/core/models/configuration.model';

export const ConfigurationApiActions = createActionGroup({
  source: 'Configuration API',
  events: {
    'Load Spaces': props<{ tenantId: string; dataSetId: number }>(),
    'Load Spaces Success': props<{ spaces: ISpace[] }>(),
    'Load Spaces Failure': props<{ error: any }>(),
    'Set Current Site': props<{ site: ISpace }>(),
    'Load Shifts': props<{ tenantId: string }>(),
    'Load Shifts Success': props<{ shifts: Shift[] }>(),
    'Load Shifts Failure': props<{ error: any }>(),
    'Load Saas Token': props<{ payload: any }>(),
    'Load Saas Token Success': props<{ blobDetails: IblobDetails }>(),
    'Load Saas Token Failure': props<{ error: any }>(),
    'Load Device Configuration': props<{ payload: any }>(),
    'Load Device Configuration Success': props<{
      devicesInformation: IDeviceConfiguration;
    }>(),
    'Load Device Configuration Failure': props<{ error: any }>(),
    'Update Device Configuration': props<{ payload: any }>(),
    'Update Device Configuration Success': props<{
      devicesInformation: IUpdateDevicesInformation;
    }>(),
    'Update Device Configuration Failure': props<{ error: any }>(),
    'Update Device Configuration Progress': props<{ progress: number }>(),
    'Update CSV': props<{ payload: any }>(),
    'Update CSV Success': props<{ success: boolean }>(),
    'Update CSV Failure': props<{ error: any }>(),
    'Set Time Zones': props<{ timeZones: ISelectItem[] }>(),
  },
});
